/* prettier-ignore */

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  private scrollContainer: HTMLElement | undefined;

  /**
   * Whether the user is (near) the bottom of the history. While true we may
   * auto-scroll on each streaming chunk; once the user scrolls up during a
   * response we stop forcing it so they can read previous messages (HRS-2423).
   */
  private pinnedToBottom = true;
  private readonly bottomThreshold = 80; // px tolerance to still count as "at bottom"
  /** último scrollTop observado: distingue un scroll-up del usuario del crecimiento del contenido */
  private lastScrollTop = 0;

  setScrollContainer(container: HTMLElement | undefined): void {
    if (this.scrollContainer)
      this.scrollContainer.removeEventListener('scroll', this._onScroll);

    this.scrollContainer = container;
    this.pinnedToBottom = true;
    this.lastScrollTop = container?.scrollTop ?? 0;

    if (container)
      container.addEventListener('scroll', this._onScroll, { passive: true });
  }

  /**
   * HRS-3045: solo se desancla cuando el usuario SUBE (scrollTop decrece). El evento
   * `scroll` de un scrollToBottom programático llega un frame tarde, y si en ese frame
   * ha entrado más contenido (tarjetas de link-preview en ráfaga, un lote de texto) la
   * distancia al fondo ya supera el umbral: con la comprobación antigua eso se leía como
   * "el usuario ha subido" y el chat se quedaba clavado a una tarjeta del final. El
   * crecimiento del contenido nunca reduce scrollTop; un scroll manual hacia arriba sí.
   */
  private _onScroll = (): void => {
    const el = this.scrollContainer;
    if (!el)
      return;

    const distance = el.scrollHeight - el.scrollTop - el.clientHeight;
    const scrolledUp = el.scrollTop < this.lastScrollTop;
    this.lastScrollTop = el.scrollTop;

    if (distance <= this.bottomThreshold)
      this.pinnedToBottom = true;
    else if (scrolledUp)
      this.pinnedToBottom = false; // HRS-2423: el usuario sube a leer mientras el bot responde
    // distancia > umbral SIN subir = el contenido ha crecido: seguimos anclados
  };

  /**
   * Scrolls to the bottom of the chat history.
   * @param force when `true`, scrolls regardless of the user position and
   *  re-pins to the bottom (used when the user sends a message). When `false`
   *  (default, streaming ticks) it only scrolls if the user is already at the
   *  bottom, so a manual scroll-up is respected while the bot is answering.
   */
  scrollToBottom(force = false): void {
    const el = this.scrollContainer;
    if (!el)
      return;

    if (!force && !this.pinnedToBottom)
      return;

    try {
      setTimeout(() => {
        el.scrollTop = el.scrollHeight;
        this.pinnedToBottom = true;
      }, 0);
    } catch (err) {}
  }

}
